import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  BUSINESS_BASE_ROUTE,
  CATCH_ALL,
  FORGOT_PASSWORD,
  INITIAL_ROUTE,
  LOGIN,
  REDIRECT_CATCH_ALL,
  TRANSLATIONS,
} from '@app/routing/global-routes';

@NgModule({
  imports: [
    RouterModule.forRoot([
      FORGOT_PASSWORD,
      LOGIN,
      INITIAL_ROUTE,
      BUSINESS_BASE_ROUTE,
      TRANSLATIONS,
      REDIRECT_CATCH_ALL,
      CATCH_ALL,
    ]),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
